module.exports = __webpack_public_path__ + "static/media/default_bild.aace3fec.png";